import React from 'react';
import { injectIntl } from 'react-intl';
import { message } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import { getClientMessages, getFields, getLanguageIntl } from '../../../../constants/messages';
import { getNestedValue } from '../../../../utilities/util';
import {
	ClearClientProgrammedDeactivation,
	GetClientProgrammedDeactivationData,
	SaveClientProgrammedDeactivationDate,
} from '../../actions';
import AccountTable from './AccountTable';
import ProgrammedDeactivationForm from './ProgrammedDeactivationForm';

let clientMessages = getClientMessages(),
	intlMessages = getLanguageIntl(),
	fieldMessages = getFields();

const messages = {
	...clientMessages,
	...intlMessages,
	...fieldMessages,
};

class PDView extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			clientData: {},
		};
	}

	componentDidMount() {
		this.loadClientData();
	}

	getIntl = (str, values = {}) => this.props.intl.formatMessage({ ...messages[str] }, values);

	loadClientData = () => {
		const { props, getIntl } = this;
		const { clientId, setLoading } = props;
		setLoading(true);
		GetClientProgrammedDeactivationData(clientId)
			.then((clientData) => {
				setLoading(false);
				this.setState({ clientData });
			})
			.catch(() => {
				setLoading(false);
				message.error(getIntl('getClientProgrammedDeactivationDataError'));
			});
	};

	formatFullDate = (unformatedDate) => {
		if (!unformatedDate) return undefined;
		const { getIntl } = this;
		const locale = getIntl('intl');
		return moment(unformatedDate).locale(locale).format('MMMM DD, YYYY, h:mm a');
	};

	renderTable = () => {
		const { clientData } = this.state;
		const accounts = getNestedValue('client.accounts', clientData) || [];
		const data = accounts.map((account) => {
			const { id, name, disableConfirmation = {} } = account;
			const { firstDateConfirmation, dateBeforeConfirmation, sameDateConfirmation } = disableConfirmation;
			return { id, name, firstDateConfirmation, dateBeforeConfirmation, sameDateConfirmation };
		});
		return <AccountTable data={data} />;
	};

	onSaveDeactivation = (newDate, comment) => {
		const {
			props: { setSaving, setLoading, clientId },
			getIntl,
			loadClientData,
		} = this;
		setSaving(true);
		setLoading(true);
		SaveClientProgrammedDeactivationDate(clientId, newDate, comment)
			.then(() => {
				setSaving(false);
				loadClientData();
			})
			.catch(() => {
				setSaving(false);
				setLoading(false);
				message.error(getIntl('updateClientProgrammedDeactivationError'));
			});
	};

	onDeleteDeactivation = () => {
		const {
			props: { setSaving, setLoading, clientId },
			getIntl,
			loadClientData,
		} = this;
		setSaving(true);
		setLoading(true);
		ClearClientProgrammedDeactivation(clientId)
			.then(() => {
				setSaving(false);
				loadClientData();
			})
			.catch(() => {
				setSaving(false);
				setLoading(false);
				message.error(getIntl('updateClientProgrammedDeactivationError'));
			});
	};

	renderDatePicker = () => {
		const {
			state: { clientData },
			props: { isLoading },
			onSaveDeactivation,
			onDeleteDeactivation,
		} = this;
		const disableDate = getNestedValue('client.disableDate.date', clientData);
		const comment = getNestedValue('client.disableDate.comment', clientData);

		return (
			<ProgrammedDeactivationForm
				onSave={onSaveDeactivation}
				onDelete={onDeleteDeactivation}
				disableDate={disableDate}
				comment={comment}
				isLoading={isLoading}
			/>
		);
	};

	fullRender = () => {
		const { state, renderTable, renderDatePicker } = this;
		const { clientData } = state;
		const disableDate = getNestedValue('client.disableDate.date', clientData);
		return (
			<div>
				{renderDatePicker()}
				{disableDate ? renderTable() : null}
			</div>
		);
	};

	render() {
		return this.fullRender();
	}
}

PDView.propTypes = {
	intl: PropTypes.object.isRequired,
	clientId: PropTypes.number.isRequired,
	setLoading: PropTypes.func.isRequired,
	setSaving: PropTypes.func.isRequired,
	isLoading: PropTypes.bool.isRequired,
};

export default injectIntl(PDView);
